import React from 'react';
import { Music2 } from 'lucide-react';
import { AudioEffect, AudioEffectControlProps } from './AudioEffect';
import { AudioSourceRegistry } from '../../../../dataTypes/liveStreamManagment/audioPipeline/AudioSourceRegistry';
import { LevelSlider } from '../LevelSlider';

export interface PitchConfig {
  /** Demi-tons, -12..+12. Négatif = plus grave, positif = plus aigu. */
  semitones: number;
}

class PitchEffectImpl extends AudioEffect<PitchConfig> {
  readonly id = 'pitch';
  readonly label = 'Pitch';
  readonly icon = Music2;
  readonly description = 'Change la hauteur de la voix (grave ↔ aigu) sans changer la vitesse';
  readonly defaultConfig: PitchConfig = { semitones: 0 };

  apply(registry: AudioSourceRegistry, regId: string, enabled: boolean, config: PitchConfig): void {
    registry.setPitch(regId, enabled, config.semitones);
  }

  renderControls({ config, onChange }: AudioEffectControlProps<PitchConfig>) {
    return (
      <LevelSlider
        label="Hauteur" value={config.semitones}
        min={-12} max={12} defaultValue={0} roundTo={1}
        format={v => v === 0 ? 'Normal' : `${v > 0 ? '+' : ''}${v} demi-tons (${v > 0 ? 'aigu' : 'grave'})`}
        onChange={semitones => onChange({ semitones })}
      />
    );
  }
}

export const pitchEffect = new PitchEffectImpl();
